"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefixLanguages = exports.prefixBreadcrumbs = exports.prefix = exports.debugDetailed = exports.debug = void 0;
exports.debug = true;
exports.debugDetailed = exports.debug && false;
exports.prefix = 'theme';
exports.prefixBreadcrumbs = `${exports.prefix}-breadcrumbs`;
exports.prefixLanguages = `${exports.prefix}-languages`;
